import React from 'react';
import { useTranslate } from '@hooks';
import { toArray } from '@dotone/react-ui-core/utils';
import { FilterBlock, FilterList } from '@dotone/react-ui-core';
import { OfferFilterBlock } from '../filters';

const AffiliationFilterList = ({ filters, ...otherProps }) => {
  const { t } = useTranslate('common');
  const { startDate, endDate, offerIds = [] } = filters;

  return (
    <FilterList {...otherProps}>
      <FilterBlock list={false} label={t('from')} items={toArray(startDate)} />
      <FilterBlock list={false} label={t('to')} items={toArray(endDate)} />
      <OfferFilterBlock ids={offerIds} />
    </FilterList>
  );
};

export default React.memo(AffiliationFilterList);
